import styles from './Spacer.module.scss';
import clsx from 'clsx';
import React from 'react';

export const Spacer = ({
  data,
  tabletSpaceInPx,
  desktopSpaceInPx,
  mobileSpaceInPx,
}) => {
  const { isBorder, borderSize, borderColor } = data;

  return (
    <div
      className={clsx(styles.spacer, {
        [styles.withBorder]: isBorder,
      })}
      style={{
        '--desktopSpaceInPx': desktopSpaceInPx + 'px',
        '--tabletSpaceInPx': tabletSpaceInPx + 'px',
        '--mobileSpaceInPx': mobileSpaceInPx + 'px',
        '--borderSize': borderSize + 'px',
        '--borderColor': borderColor,
      }}
     />
  );
};
